<template>
  <b-modal
    id="trinh-xac-thuc"
    ref="authenticator"
    title="Trình xác thực đăng nhập"
    size="lg"
    centered
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="mb-1">
      <!-- Phase 9b: block xác minh email (khi guard BE trả EMAIL_UNVERIFIED cho generate-setupcode) -->
      <div v-if="needVerify" class="verify-email">
        <div class="title font-weight-bold">Xác minh email trước khi kích hoạt</div>
        <p class="text-muted mt-1">
          Bạn cần xác minh email trước khi kích hoạt xác thực 2 bước. Mã 6 số sẽ được gửi tới email đã đăng ký.
        </p>
        <b-button
          variant="outline-primary"
          size="sm"
          class="mb-2"
          :disabled="isLoading"
          @click="requestCode"
          >Gửi mã về email</b-button
        >
        <div class="mb-1 font-weight-bold">Mã xác minh</div>
        <b-form-input
          v-model="verifyCode"
          type="text"
          inputmode="numeric"
          maxlength="6"
          class="outline-primary input"
          placeholder="Mã 6 số"
          @keyup.enter="verifyEmail"
        />
        <p class="text-muted mt-1" style="font-size: 0.85rem">
          Không nhận được mã? Liên hệ quản trị viên.
        </p>
      </div>

      <div v-else class="authenticator">
        <div class="title font-weight-bold">Kích hoạt tính năng xác thực hai bước</div>
        <div class="sub-title mt-1 font-size-14">
          Để sử dụng ứng dụng xác thực, hãy thực hiện các bước sau:
        </div>
        <div class="content pl-1 mt-2">
          <p>
            1. <b>Khuyến dùng:</b> cài ứng dụng <b>eDoc Mobile</b> - dùng chính
            app eDoc để nhận mã xác thực, không cần cài thêm ứng dụng nào khác.
            Tải ứng dụng eDoc Mobile
            <!-- TODO(open-question): app QLVB chua len store cong khai; thay bang URL that khi co (CH Play / App Store / portal noi bo). -->
            <a href="#" target="_blank" @click.prevent>tại đây</a>.
            <br />
            Hoặc bạn có thể dùng ứng dụng xác thực khác như Google Authenticator
            cho
            <a
              href="https://play.google.com/store/search?q=authenticator+google&c=apps&hl=vi&gl=US"
              target="_blank"
              >Android</a
            >
            và
            <a
              href="https://apps.apple.com/vn/app/google-authenticator/id388497605?l=vi"
              target="_blank"
              >iOS</a
            >.
          </p>
          <p v-if="valueAuthenticator && !isLoading">
            2. Quét Mã QR hoặc nhập khóa này
            <span
              class="code-otp"
              @click="copyOTP(valueAuthenticator.manualSetupCodeText)"
              >{{ valueAuthenticator.manualSetupCodeText }}
              <span v-if="showTooltip" class="tool-tip"> Copy thành công </span>
            </span>
            vào ứng dụng xác thực hai yếu tố của bạn. Để kích hoạt tính năng tạo
            mã QR, vui lòng đọc tài liệu của chúng tôi
          </p>
          <div class="d-flex align-items-end">
            <img
              v-if="valueAuthenticator && !isLoading"
              :src="valueAuthenticator.qrCodeImageUrl"
              alt=""
            />
            <!--            <a-->
            <!--              href="#"-->
            <!--              class="change-code d-flex align-items-center"-->
            <!--              @click="generateAuthenticator"-->
            <!--            >-->
            <!--              <feather-icon size="13" icon="RefreshCwIcon" class="mr-40" />-->
            <!--              <span>Đổi mã xác thực</span></a-->
            <!--            >-->
          </div>
          <p class="mt-1">
            3. Sau khi bạn quét mã QR hoặc nhập khóa ở trên, ứng dụng xác thực
            hai yếu tố sẽ cung cấp cho bạn một mã duy nhất. Nhập mã vào ô xác
            nhận bên dưới
          </p>
          <div class="mb-1 font-weight-bold">Mã xác thực</div>
          <b-form-input
            v-otp-autofocus
            ref="inputMaXacThuc"
            v-model="otpAuthenticator"
            type="text"
            inputmode="numeric"
            maxlength="6"
            autocomplete="one-time-code"
            pattern="[0-9]*"
            class="outline-primary input"
            placeholder="Mã OTP"
            @keyup.enter="activeAuthenticator"
          />
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <div class="w-100 text-right">
        <!-- Phase 9b: nút xác nhận mã verify email -->
        <base-button
          v-if="needVerify"
          button="Xác nhận mã"
          :disabled="!verifyCode"
          @click="verifyEmail"
        />
        <base-button
          v-else
          button="Xác thực"
          :disabled="!otpAuthenticator"
          @click="activeAuthenticator()"
        />
        <b-button variant="outline-primary" class="ml-1" @click="hideModal()"
          >Đóng</b-button
        >
      </div>
    </template>
    <BaseLoading :is-loading="isLoading" />
  </b-modal>
</template>

<script>
import { showMsgError } from "@/utils/commonUtils";
import BaseLoading from "../../common/BaseLoading";

export default {
  name: 'ModalAuthenticator',
  components: {BaseLoading},
  props: {
    tokenApiCommon: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isRequireSetup2FA: false,
      otpAuthenticator: null,
      showTooltip: false,
      isLoading: false,
      valueAuthenticator: null,
      tokenCommon: null,
      isAuthenticator: false,
      needVerify: false, // Phase 9b: guard BE trả EMAIL_UNVERIFIED -> hiện block xác minh email.
      verifyCode: null,
    }
  },
  methods: {
    resetData() {
      this.otpAuthenticator = null
      this.showTooltip = false
      this.valueAuthenticator = null
      this.tokenCommon = null
      this.isAuthenticator = false
      this.isRequireSetup2FA = false
      this.needVerify = false
      this.verifyCode = null
    },
    generateAuthenticator() {
      this.isLoading = true
      return this.$store
        .dispatch('common/changeGenerateSetupCode')
        .then((res) => {
          this.isLoading = false
          if (res.succeeded) {
            this.needVerify = false
            this.valueAuthenticator = res.data
            this.isAuthenticator = true
          }
        })
        .catch((error) => {
          this.isLoading = false
          // Phase 9b: guard chặn về HTTP 400 -> vào ĐÂY. code EMAIL_UNVERIFIED -> hiện block xác minh email.
          if (error && error.data && error.data.code === 'EMAIL_UNVERIFIED') {
            this.needVerify = true
            return
          }
          this.$toasted.global.showErrorMessage({
            message: (error.data && (error.data.message || error.data.code)) || 'Có lỗi xảy ra',
          })
        })
    },
    // Phase 9b: user tự yêu cầu gửi mã kích hoạt về email đã đăng ký.
    requestCode() {
      this.isLoading = true
      this.$store
        .dispatch('common/requestActivationSelf')
        .then((res) => {
          this.isLoading = false
          if (res.succeeded) {
            this.$toasted.global.showSuccessMessage({
              message: 'Đã gửi mã xác minh tới email đã đăng ký.',
            })
          } else {
            this.$toasted.global.showErrorMessage({
              message: res.message || 'Không gửi được mã. Vui lòng thử lại.',
            })
          }
        })
        .catch((error) => {
          this.isLoading = false
          this.$toasted.global.showErrorMessage({
            message: (error.data && error.data.message) || 'Có lỗi xảy ra',
          })
        })
    },
    // Phase 9b: verify mã email -> BE đặt marker -> tự retry generate-setupcode.
    verifyEmail() {
      if (!this.verifyCode) return
      this.isLoading = true
      this.$store
        .dispatch('common/verifyActivation', { code: String(this.verifyCode).trim() })
        .then((res) => {
          this.isLoading = false
          if (res.succeeded) {
            this.needVerify = false
            this.verifyCode = null
            this.generateAuthenticator() // marker vừa đặt -> lần này qua guard -> hiện QR.
          } else {
            this.$toasted.global.showErrorMessage({
              message: res.message || 'Mã không đúng hoặc đã hết hạn.',
            })
          }
        })
        .catch((error) => {
          this.isLoading = false
          this.$toasted.global.showErrorMessage({
            message: (error.data && error.data.message) || 'Có lỗi xảy ra',
          })
        })
    },
    validateAuthenticator() {
      this.isLoading = true
      this.$store
        .dispatch('common/validateLogin', {
          twoFactorCode: this.otpAuthenticator,
        })
        .then((res) => {
          if (res.succeeded) {
            this.isLoading = false
            this.$emit('authenticator', res)
            this.hideModal()
          }
        })
        .catch((error) => {
          this.isLoading = false
          this.$toasted.global.showErrorMessage({
            message: error.data.message || 'Có lỗi xảy ra'
          });
        })
    },
    activeAuthenticator() {
      this.$store
        .dispatch('common/confirmUsing', {
          twoFactorCode: this.otpAuthenticator,
        })
        .then((res) => {
          if (res.succeeded) {
            this.validateAuthenticator()
          }
          this.$toasted.global.showSuccessMessage({
            message: 'Xác thực thành công' || res.data.message,
          });
        })
        .catch((error) => {
          this.isLoading = false
          this.$toasted.global.showErrorMessage({
            message: error.data.message || 'Có lỗi xảy ra'
          });
        })
    },
    copyOTP(value) {
      navigator.clipboard.writeText(value)
      this.showTooltip = true
      setTimeout(() => {
        this.showTooltip = false
      }, 1000)
    },
    async showModal(dataModal) {
      await this.generateAuthenticator()
      await this.$refs.authenticator.show()
      this.tokenCommon = dataModal.token
      this.isRequireSetup2FA = dataModal.isRequireSetup2FA
    },
    hideModal() {
      this.resetData()
      this.$refs.authenticator.hide()
    },
  },
}
</script>
<style lang="scss" scoped>
.authenticator {
  font-size: 14px;
  .change-code {
    margin-bottom: 12px;
    & span {
      margin-bottom: -2px;
    }
    .mr-40 {
      margin-right: 4px;
    }
  }
  .title {
    font-size: 16px;
  }
  // .code-otp - style global tại assets/css/components/_otp.scss (dùng chung ModalRegisterDevice).
  .input {
    max-width: 50%;
  }
}
.otp-authenticator {
  .input {
    max-width: 69%;
  }
}
.img {
  width: 30%;
  margin: auto;
  & img {
    width: 100%;
    height: auto;
  }
}
.input {
  border: 1px solid #5a8dee;
  height: 36px;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    display: none;
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield; /* Firefox */
  }
}
</style>
